<template>
  <pdf src="/files/Mqtt.pdf" v-for="i in 7" :key="i" :page="i"></pdf>
</template>

<script>
import pdf from "vue3-pdf";
export default {
  components: {
    pdf,
  },
};
</script>

<style></style>
